"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return "\n    <rect x=\"16\" y=\"8\" width=\"44\" height=\"4\" rx=\"2\" fill=\"black\" fill-opacity=\"0.8\"/>\n";
};